import { Platform } from 'quasar'

export function detectPlatform() {
  // Quasar-first detection (preferred when available)
  const quasarIsElectron = !!Platform?.is?.electron
  const quasarIsCapacitor = !!Platform?.is?.capacitor

  // Fallback signals used in this codebase / early boot contexts
  // const fallbackIsElectron = typeof window !== 'undefined' && !!window?.electronAPI?.isElectron
  // const fallbackIsCapacitor = typeof window !== 'undefined' && !!window?.Capacitor

  const isElectron = quasarIsElectron // || fallbackIsElectron
  const isCapacitor = quasarIsCapacitor // || fallbackIsCapacitor
  const isWeb = !isElectron && !isCapacitor

  return { isWeb, isElectron, isCapacitor }
}

export function resolveDbName(baseName = 'blu-local') {
  const { isElectron, isCapacitor } = detectPlatform()
  // Keep a stable name per platform so caches don't clash between builds.
  if (isElectron) return `${baseName}-electron`
  if (isCapacitor) return `${baseName}-capacitor`
  return `${baseName}-web`
}

